export default __webpack_public_path__ + "static/media/christmasCard.64b30c42.jpg";